import { ofetch } from 'ofetch'
import { defineStore } from 'pinia'

const BACKEND_API_URL = import.meta.env.VITE_BACKEND_API_URL

const DEFAULT_PRIMARY_COLOR = '#F15921'

const DEFAULT_TERMINOLOGY = {
  "Customer": "Customer",
  "customer": "customer",
}

export const useTenantStore = defineStore('tenantStore', {
  state: () => ({
    tenant: JSON.parse(localStorage.getItem('tenant_config')) ?? null,
    resolved: false,
    error: null,
    errorStatus: null,
  }),

  getters: {
    id: state => state.tenant?.id,
    name: state => state.tenant?.name,
    apiUrl: state => state.tenant?.api_url,
    logo: state => state.tenant?.metadata?.logo || null,
    loginBanner: state => state.tenant?.metadata?.login_banner || null,
    primaryColor: state => state.tenant?.metadata?.theme?.primary_color || DEFAULT_PRIMARY_COLOR,
    secondaryColor: state => state.tenant?.metadata?.theme?.secondary_color || null,
    terminology: state => ({
      ...DEFAULT_TERMINOLOGY,
      ...state.tenant?.metadata?.terminology,
    }),
  },

  actions: {
    async resolve(vuetify, i18n) {
      if (this.resolved && this.tenant) {
        this.applyTheme(vuetify)
        this.applyTerminology(i18n)

        return
      }

      try {
        const response = await ofetch(`${BACKEND_API_URL}/validate-domain`, {
          headers: { Accept: 'application/json' },
        })

        if (response.success && response.tenant) {
          this.tenant = response.tenant
          this.error = null
          this.errorStatus = null
          localStorage.setItem('tenant_config', JSON.stringify(response.tenant))
        }
      } catch (err) {
        console.error('Failed to resolve tenant:', err)
        this.errorStatus = err.statusCode || err.status || null
        this.error = err.data?.message || err.message || 'Failed to resolve tenant'

        if (!this.tenant && !this.errorStatus) {
          this.error = 'Tenant not found. Please check the URL.'
        }
      } finally {
        this.resolved = true
      }

      this.applyTheme(vuetify)
      this.applyTerminology(i18n)
    },

    applyTheme(vuetify) {
      if (!vuetify) return

      const primaryColor = this.primaryColor
      if (primaryColor && primaryColor !== DEFAULT_PRIMARY_COLOR) {
        vuetify.theme.themes.value.client.colors.primary = primaryColor
      }

      if (this.secondaryColor) {
        vuetify.theme.themes.value.client.colors.secondary = this.secondaryColor
      }
    },

    applyTerminology(i18n) {
      if (!i18n) return

      i18n.global.mergeLocaleMessage('en', this.terminology)
    },

    clear() {
      this.tenant = null
      this.resolved = false
      this.error = null
      this.errorStatus = null
      localStorage.removeItem('tenant_config')
    },
  },
})
